/**
 * Created by lihanying on 2018/1/12.
 */
import React from 'react'
import { Modal, Input, Table } from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import { changeToDecimal } from '../../../util'
const Search = Input.Search
export default class extends React.Component {
  state = {
    page: 1,
  }
  render() {
    const { modalOut, clubCommodityOut } = this.props
    const columns = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '商品名称',
        dataIndex: 'commodity_name',
        key: 'commodity_name',
      },
      {
        title: '类型',
        dataIndex: 'typename',
        key: 'typename',
      },
      {
        title: '零售价',
        dataIndex: 'commodity_price',
        key: 'commodity_price',
        sorter: (a, b) => a.commodity_price - b.commodity_price,
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '操作',
        dataIndex: 'edit',
        key: 'edit',
        render: (text, record, index) => {
          return (
            <div style={{ color: '#108EE9', cursor: 'default' }}>
              <Popconfirm
                title="上架后该商品即可恢复正常销售,请是否确认?"
                okText="确认"
                cancelText="取消"
                onConfirm={() =>
                  this.props.fetchSetCommodity(
                    'Shelves',
                    { id: record.id },
                    { p: this.state.page, out: 1 }
                  )
                }
              >
                上架
              </Popconfirm>
            </div>
          )
        },
      },
    ]
    return (
      <div>
        <Modal
          title="下架商品"
          visible={modalOut}
          onCancel={this.props.handleCancel}
          width="800px"
          footer={null}
        >
          <Search
            placeholder="请输入关键字查询"
            style={{ width: 200 }}
            onSearch={(value) =>
              this.props.fetchClubCommodity({ search: value, p: 1, out: 1 })
            }
          />
          <Table
            rowKey="id"
            bordered
            columns={columns}
            dataSource={clubCommodityOut.list}
            size="middle"
            pagination={{ pageSize: 5, total: clubCommodityOut.count }}
            onChange={(page) =>
              this.setState({ page: page.current }, () =>
                this.props.fetchClubCommodity({
                  search: clubCommodityOut.parameter.searchInput,
                  p: page.current,
                  out: 1,
                })
              )
            }
          />
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubCommodity/component/modalOut.js